module.exports = __webpack_public_path__ + "img/pt-box4-text-dark.b8484b7d.png";